import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "confirm-tick-overlay"
};
const _hoisted_2 = { class: "modal-header" };
const _hoisted_3 = { class: "header-left" };
const _hoisted_4 = {
    key: 0,
    class: "progress-indicator"
};
const _hoisted_5 = {
    key: 0,
    class: "transaction-info"
};
const _hoisted_6 = { class: "transaction-info-left" };
const _hoisted_7 = { class: "merchant-name" };
const _hoisted_8 = {
    key: 0,
    class: "transaction-date"
};
const _hoisted_9 = { class: "transaction-info-right" };
const _hoisted_10 = { class: "transaction-amount" };
const _hoisted_11 = {
    key: 0,
    class: "merchant-count"
};
const _hoisted_12 = { class: "search-section" };
const _hoisted_13 = {
    key: 1,
    class: "suggestion-banner"
};
const _hoisted_14 = { class: "suggestion-content" };
const _hoisted_15 = { class: "suggestion-text" };
const _hoisted_16 = { class: "category-panels" };
const _hoisted_17 = { class: "parent-panel" };
const _hoisted_18 = { class: "parent-list" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "parent-name" };
const _hoisted_21 = { class: "subcategory-panel" };
const _hoisted_22 = { class: "panel-header" };
const _hoisted_23 = ["data-id", "onClick"];
const _hoisted_24 = { class: "subcategory-name" };
const _hoisted_25 = ["data-id", "onClick"];
const _hoisted_26 = { class: "subcategory-name" };
const _hoisted_27 = ["data-id", "onClick"];
const _hoisted_28 = { class: "subcategory-name" };
const _hoisted_29 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_30 = { class: "toggle-section" };
const _hoisted_31 = { class: "toggle-row" };
const _hoisted_32 = { class: "toggle-row" };
const _hoisted_33 = {
    key: 2,
    class: "tags-section"
};
const _hoisted_34 = { class: "modal-actions" };
const _hoisted_35 = ["disabled"];
import { ref, computed, watch, nextTick } from 'vue';
import { useTransactions } from '../../composables/useTransactions';
import { useCustomer } from '../../composables/useCustomer';
import { useAppState } from '../../composables/useAppState';
import { GRANDPARENT_CLASSIFICATIONS } from '../../composables/useSpendingAnalysis';
import MGToggle from '../../components/elements/MGToggle.vue';
import TagInput from '../../components/elements/TagInput.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionTaggingModal',
    props: {
        visible: { type: Boolean },
        transactionData: {},
        colourMode: { default: 'light' },
        bulkMode: { type: Boolean, default: false },
        bulkModeIndex: { default: 0 },
        bulkModeTotal: { default: 0 },
        merchantCount: { default: 1 }
    },
    emits: ["close", "tagged", "next", "previous"],
    setup(__props, { emit: __emit }) {
        const transactions = useTransactions();
        const customer = useCustomer();
        const state = useAppState();
        const props = __props;
        const emit = __emit;
        const modal = ref(null);
        const subcategoryList = ref(null);
        const searchQuery = ref('');
        const classifications = ref([]);
        const suggestedClassification = ref(null);
        const loadingSuggestion = ref(false);
        const selectedParent = ref(null);
        const selectedClassificationId = ref(null);
        const selectedClassificationObj = ref(null);
        const alwaysApplyTag = ref(true);
        const excludeFromAnalysis = ref(false);
        const parentCategories = ref([]);
        const localTransaction = ref(null);
        const availableTags = ref(null);
        const selectedTags = ref([]);
        const showConfirmTick = ref(false);
        const saving = ref(false);
        const isUncategorized = computed(() => {
            if (!localTransaction.value)
                return true;
            const classification = localTransaction.value.customerClassification || localTransaction.value.effectiveClassification;
            return !classification || classification.mgClassification === 'Uncategorized';
        });
        const filteredParentCategories = computed(() => {
            if (!searchQuery.value)
                return parentCategories.value;
            const q = searchQuery.value.toLowerCase();
            return parentCategories.value.filter((parent) => {
                if (parent.name.toLowerCase().includes(q))
                    return true;
                return parent.categories.some((cat) => cat.mgClassification.fullName.toLowerCase().includes(q) ||
                    cat.children?.some((child) => (child.mgClassification.mgSubClassification || child.mgClassification.fullName).toLowerCase().includes(q)));
            });
        });
        const filteredSubcategories = computed(() => {
            if (!selectedParent.value)
                return [];
            if (!searchQuery.value)
                return selectedParent.value.categories;
            const q = searchQuery.value.toLowerCase();
            return selectedParent.value.categories.filter((cat) => {
                if (cat.mgClassification.fullName.toLowerCase().includes(q))
                    return true;
                return cat.children?.some((child) => (child.mgClassification.mgSubClassification || child.mgClassification.fullName).toLowerCase().includes(q));
            });
        });
        const canConfirm = computed(() => {
            return selectedClassificationId.value !== null;
        });
        watch(() => props.visible, (newVal) => {
            if (newVal && props.transactionData) {
                initModal();
            }
            else if (!newVal) {
                resetState();
            }
        }, { immediate: true });
        watch(() => props.transactionData, (newVal) => {
            if (props.visible && newVal) {
                initModal();
            }
        }, { immediate: true });
        function initModal() {
            localTransaction.value = { ...props.transactionData };
            excludeFromAnalysis.value = props.transactionData?.excludeFromAnalysis || false;
            const current = props.transactionData?.customerClassification || props.transactionData?.effectiveClassification;
            if (current?.id && current.mgClassification !== 'Uncategorized') {
                selectedClassificationId.value = current.id;
            }
            if (props.transactionData.customerTags && Array.isArray(props.transactionData.customerTags)) {
                selectedTags.value = props.transactionData.customerTags.map((t) => t.tag);
            }
            else {
                selectedTags.value = [];
            }
            loadData();
        }
        function loadData() {
            transactions.getTransactionClassifications((result) => {
                classifications.value = result;
                buildParentCategories();
                selectParentFromCurrentSelection();
                nextTick(() => {
                    scrollToSelectedSubcategory();
                });
            });
            customer.getCustomerTags(() => {
                if (state.customerTags && Array.isArray(state.customerTags)) {
                    availableTags.value = state.customerTags.map((t) => t.tag);
                }
                else {
                    availableTags.value = [];
                }
            });
            if (isUncategorized.value && localTransaction.value?.merchantName) {
                loadingSuggestion.value = true;
                transactions.getSuggestedClassification(localTransaction.value.merchantName, (suggestion) => {
                    suggestedClassification.value = suggestion;
                    loadingSuggestion.value = false;
                });
            }
        }
        function buildParentCategories() {
            const incomeCategories = classifications.value.filter((c) => c.mgClassification.grandParentClassification === GRANDPARENT_CLASSIFICATIONS.INCOME);
            const futureCategories = classifications.value.filter((c) => c.mgClassification.grandParentClassification === GRANDPARENT_CLASSIFICATIONS.FUTURE_PLANNING);
            const everydayCategories = classifications.value.filter((c) => c.mgClassification.grandParentClassification === GRANDPARENT_CLASSIFICATIONS.EVERYDAY_SPEND);
            const committedCategories = classifications.value.filter((c) => c.mgClassification.grandParentClassification === GRANDPARENT_CLASSIFICATIONS.FIXED_COSTS);
            parentCategories.value = [
                { name: 'Income', categories: incomeCategories, colour: '#B4D8D7' },
                { name: 'Future Plans', categories: futureCategories, colour: '#D5C9C8' },
                { name: 'Everyday', categories: everydayCategories, colour: '#9EA2D0' },
                { name: 'Committed', categories: committedCategories, colour: '#413655' }
            ];
        }
        function selectParentFromCurrentSelection() {
            if (!selectedClassificationId.value) {
                if (parentCategories.value.length > 0) {
                    selectedParent.value = parentCategories.value[0];
                }
                return;
            }
            for (const parent of parentCategories.value) {
                for (const cat of parent.categories) {
                    if (cat.mgClassification.id === selectedClassificationId.value) {
                        selectedParent.value = parent;
                        selectedClassificationObj.value = cat;
                        return;
                    }
                    for (const child of cat.children || []) {
                        if (child.mgClassification.id === selectedClassificationId.value) {
                            selectedParent.value = parent;
                            selectedClassificationObj.value = child;
                            return;
                        }
                    }
                }
            }
            if (parentCategories.value.length > 0) {
                selectedParent.value = parentCategories.value[0];
            }
        }
        function selectParent(parent) {
            selectedParent.value = parent;
        }
        function selectCategory(category) {
            selectedClassificationId.value = category.mgClassification.id;
            selectedClassificationObj.value = category;
            nextTick(() => {
                const actions = modal.value?.querySelector('.modal-actions');
                if (actions) {
                    actions.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            });
        }
        function applySuggestion() {
            if (!suggestedClassification.value)
                return;
            const found = findClassificationById(suggestedClassification.value.id);
            if (found) {
                selectedClassificationId.value = found.mgClassification.id;
                selectedClassificationObj.value = found;
                selectParentFromCurrentSelection();
                nextTick(() => {
                    scrollToSelectedSubcategory();
                    const actions = modal.value?.querySelector('.modal-actions');
                    if (actions) {
                        actions.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                });
            }
        }
        function scrollToSelectedSubcategory() {
            if (!subcategoryList.value || !selectedClassificationId.value)
                return;
            const selectedEl = subcategoryList.value.querySelector(`[data-id="${selectedClassificationId.value}"]`);
            if (selectedEl) {
                selectedEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        function findClassificationById(id) {
            for (const cat of classifications.value) {
                if (cat.mgClassification.id === id)
                    return cat;
                for (const child of cat.children || []) {
                    if (child.mgClassification.id === id)
                        return child;
                }
            }
            return null;
        }
        function confirmTag() {
            if (!selectedClassificationObj.value || !localTransaction.value?.id || saving.value)
                return;
            saving.value = true;
            const updatedTransaction = {
                id: localTransaction.value.id,
                bankAccountID: localTransaction.value.bankAccountID,
                merchantName: localTransaction.value.merchantName,
                amount: localTransaction.value.amount,
                customerClassification: selectedClassificationObj.value.mgClassification,
                effectiveClassification: selectedClassificationObj.value.mgClassification,
                excludeFromAnalysis: excludeFromAnalysis.value,
                alwaysApplyTag: alwaysApplyTag.value
            };
            const onSuccess = () => {
                saving.value = false;
                emit('tagged', updatedTransaction);
                showConfirmTick.value = true;
                setTimeout(() => {
                    showConfirmTick.value = false;
                    if (props.bulkMode) {
                        resetState();
                        emit('next');
                    }
                    else {
                        emit('close');
                    }
                }, 800);
            };
            if (alwaysApplyTag.value) {
                const payload = {
                    alwaysExcludeFromAnalysis: excludeFromAnalysis.value,
                    merchantName: localTransaction.value.merchantName,
                    chosenTransactionClassification: {
                        mgClassification: selectedClassificationObj.value.mgClassification.mgClassification,
                        mgSubClassification: selectedClassificationObj.value.mgClassification.mgSubClassification,
                        grandParentClassification: selectedClassificationObj.value.mgClassification.grandParentClassification
                    }
                };
                transactions.updateTransactionClassificationMerchantRule(payload, props.bulkMode ? () => { } : onSuccess);
            }
            else {
                transactions.updateTransactionClassification(updatedTransaction, props.bulkMode ? () => { } : onSuccess);
            }
            if (props.bulkMode) {
                onSuccess();
            }
        }
        function getParentStyle(parent) {
            if (selectedParent.value?.name === parent.name) {
                return {
                    backgroundColor: parent.colour,
                    color: parent.colour === '#413655' ? 'white' : '#1a1a1a'
                };
            }
            return {};
        }
        function formatDate(timestamp) {
            const date = new Date(timestamp);
            let result = date.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
            if (date.getHours() !== 0 || date.getMinutes() !== 0) {
                result += ' · ' + date.toLocaleTimeString('en-GB', {
                    hour: '2-digit',
                    minute: '2-digit'
                });
            }
            return result;
        }
        function formatAmount(amount) {
            if (!amount)
                return '£0.00';
            const formatted = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
            }).format(Math.abs(amount));
            return amount < 0 ? `-${formatted}` : formatted;
        }
        function resetState() {
            searchQuery.value = '';
            suggestedClassification.value = null;
            loadingSuggestion.value = false;
            selectedParent.value = null;
            selectedClassificationId.value = null;
            selectedClassificationObj.value = null;
            alwaysApplyTag.value = true;
            excludeFromAnalysis.value = false;
            localTransaction.value = null;
            availableTags.value = null;
            selectedTags.value = [];
            saving.value = false;
        }
        function handleTagsChange(tags) {
            const updatedTags = tags.map((newTag) => {
                const existingTag = localTransaction.value.customerTags?.find((t) => t.tag === (newTag.tag || newTag));
                if (existingTag) {
                    return { tag: existingTag.tag, id: existingTag.id };
                }
                return { tag: newTag.tag || newTag };
            });
            transactions.updateTransactionTags(localTransaction.value.bankAccountID, localTransaction.value.id, updatedTags, () => {
                customer.clearCustomerTagsCache();
                localTransaction.value.customerTags = updatedTags;
                selectedTags.value = tags;
                emit('tagged', {
                    ...localTransaction.value,
                    customerTags: updatedTags
                });
            });
        }
        function handleNewTag() {
            // Tag was added - nothing extra needed, handleTagsChange handles the API call
        }
        function onDialogUpdate(value) {
            if (!value) {
                emit('close');
            }
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": _ctx.visible,
                "onUpdate:modelValue": onDialogUpdate,
                "max-width": "650px",
                persistent: "",
                class: "tagging-modal-dialog"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(["tagging-modal", _ctx.colourMode]),
                        ref_key: "modal",
                        ref: modal
                    }, [
                        _createVNode(_Transition, { name: "tick-fade" }, {
                            default: _withCtx(() => [
                                (showConfirmTick.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createVNode(_component_v_icon, {
                                            size: "80",
                                            color: "#4CAF50"
                                        }, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode("mdi-check-circle")
                                            ])),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "modal-title" }, "Tag Transaction", -1)),
                                (_ctx.bulkMode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.bulkModeIndex + 1) + " of " + _toDisplayString(_ctx.bulkModeTotal), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                            }, [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                        _createTextVNode("mdi-close")
                                    ])),
                                    _: 1
                                })
                            ])
                        ]),
                        (localTransaction.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(localTransaction.value.merchantName || 'Unknown Merchant'), 1),
                                    (localTransaction.value.timestamp)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(formatDate(localTransaction.value.timestamp)), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(formatAmount(localTransaction.value.amount)), 1),
                                    (_ctx.merchantCount > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.merchantCount) + " transactions", 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_v_text_field, {
                                modelValue: searchQuery.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                "prepend-inner-icon": "mdi-magnify",
                                density: "compact",
                                placeholder: "Search categories...",
                                variant: "outlined",
                                "hide-details": "",
                                clearable: "",
                                "single-line": ""
                            }, null, 8, ["modelValue"])
                        ]),
                        (isUncategorized.value && suggestedClassification.value && !searchQuery.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_v_icon, {
                                        size: "20",
                                        color: "#413655"
                                    }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("mdi-lightbulb-outline")
                                        ])),
                                        _: 1
                                    }),
                                    _createElementVNode("span", _hoisted_15, [
                                        _cache[11] || (_cache[11] = _createTextVNode(" Suggested: ")),
                                        _createElementVNode("strong", null, _toDisplayString(suggestedClassification.value.fullName), 1)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    class: "apply-suggestion-btn",
                                    onClick: applySuggestion
                                }, "Apply")
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "panel-header" }, "Categories", -1)),
                                _createElementVNode("div", _hoisted_18, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredParentCategories.value, (parent) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: parent.name,
                                            class: _normalizeClass(['parent-item', { selected: selectedParent.value?.name === parent.name }]),
                                            style: _normalizeStyle(getParentStyle(parent)),
                                            onClick: ($event) => (selectParent(parent))
                                        }, [
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(parent.name), 1),
                                            (parent.categories.length)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    size: "16"
                                                }, {
                                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                        _createTextVNode("mdi-chevron-right")
                                                    ])),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ], 14, _hoisted_19));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(selectedParent.value?.name || 'Subcategories'), 1),
                                (selectedParent.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "subcategory-list",
                                        ref_key: "subcategoryList",
                                        ref: subcategoryList
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSubcategories.value, (category) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: category.mgClassification.id
                                            }, [
                                                (!category.mgClassification.mgSubClassification && category.children.length === 0)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: _normalizeClass(['subcategory-item', { selected: selectedClassificationId.value === category.mgClassification.id }]),
                                                        "data-id": category.mgClassification.id,
                                                        onClick: ($event) => (selectCategory(category))
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["radio-dot", { checked: selectedClassificationId.value === category.mgClassification.id }])
                                                        }, null, 2),
                                                        _createElementVNode("span", _hoisted_24, _toDisplayString(category.mgClassification.fullName), 1)
                                                    ], 10, _hoisted_23))
                                                    : _createCommentVNode("", true),
                                                (category.children.length > 0)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: _normalizeClass(['subcategory-item', { selected: selectedClassificationId.value === category.mgClassification.id }]),
                                                        "data-id": category.mgClassification.id,
                                                        onClick: ($event) => (selectCategory(category))
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["radio-dot", { checked: selectedClassificationId.value === category.mgClassification.id }])
                                                        }, null, 2),
                                                        _createElementVNode("span", _hoisted_26, _toDisplayString(category.mgClassification.fullName), 1)
                                                    ], 10, _hoisted_25))
                                                    : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (child) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: child.mgClassification.id,
                                                        class: _normalizeClass(['subcategory-item child', { selected: selectedClassificationId.value === child.mgClassification.id }]),
                                                        "data-id": child.mgClassification.id,
                                                        onClick: ($event) => (selectCategory(child))
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["radio-dot", { checked: selectedClassificationId.value === child.mgClassification.id }])
                                                        }, null, 2),
                                                        _createElementVNode("span", _hoisted_28, _toDisplayString(child.mgClassification.mgSubClassification || child.mgClassification.fullName), 1)
                                                    ], 10, _hoisted_27));
                                                }), 128))
                                            ], 64));
                                        }), 128))
                                    ], 512))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_29, " Select a category from the left "))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("label", _hoisted_31, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "toggle-label" }, "Always apply to this merchant", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: alwaysApplyTag.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((alwaysApplyTag).value = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("label", _hoisted_32, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "toggle-label" }, "Exclude from Spending Analysis", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: excludeFromAnalysis.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((excludeFromAnalysis).value = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ]),
                        (localTransaction.value && availableTags.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tags-label" }, "#Tags", -1)),
                                _createVNode(TagInput, {
                                    selectableTags: availableTags.value,
                                    modelValue: selectedTags.value,
                                    maxTags: 5,
                                    maxTagLength: 20,
                                    onChange: handleTagsChange,
                                    onAddedNew: handleNewTag
                                }, null, 8, ["selectableTags", "modelValue"])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                                class: "cancel-btn",
                                onClick: _cache[4] || (_cache[4] = ($event) => (emit('close')))
                            }, "Cancel"),
                            (_ctx.bulkMode && _ctx.bulkModeIndex > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "skip-btn",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (emit('previous')))
                                }, "Previous"))
                                : _createCommentVNode("", true),
                            (_ctx.bulkMode)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "skip-btn",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (emit('next')))
                                }, "Skip"))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                class: "confirm-btn",
                                disabled: !canConfirm.value || saving.value,
                                onClick: confirmTag
                            }, [
                                (saving.value)
                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                        key: 0,
                                        indeterminate: "",
                                        size: "16",
                                        width: "2",
                                        color: "white",
                                        class: "mr-2"
                                    }))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(saving.value ? 'Saving...' : 'Confirm'), 1)
                            ], 8, _hoisted_35)
                        ])
                    ], 2)
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
